import React from 'react'
import Config from '../../../Core/Config'
import Logger from '../../Utils/Logger'
import { createResizableColumn } from './Resizable'
import getStorage from '../../Services/Storage'

const storageService = getStorage()

export const useResizableColumns = (id, name, data, displayColumns, loading, { disabled }) => {
  React.useEffect(() => {
    if (loading || disabled || !Config.ui.enableChangelistTableColumnsResizing) return

    const table = document.getElementById(`id-table-${name}`)
    if (!table) return

    const applyColumnResizing = () => {
      try {
        const cols = table.querySelectorAll(':scope > thead > tr > th')
        const resizingSettings = storageService.get(`${id}_CHANGELIST_TABLE_RESIZING`, null)

        const handleSave = (idx, w) => {
          const data = storageService.get(`${id}_CHANGELIST_TABLE_RESIZING`, {})
          data[idx] = w
          storageService.save(`${id}_CHANGELIST_TABLE_RESIZING`, data)
        }

        cols.forEach((col, index) => {
          if (col.classList.contains('fix')) return

          const width = getOrCalculateColumnWidth(col, index, resizingSettings, handleSave)
          applyWidthToColumn(col, width)
          applyWidthToColumnCells(table, index, width)
          setupColumnResizer(col, table, index, handleSave)
        })
      } catch (e) {
        Logger.warning('Changelist table useResizing hook error', name, e)
      }
    }

    const getOrCalculateColumnWidth = (col, index, settings, saveFn) => {
      if (!settings || !settings[index]) {
        const styles = window.getComputedStyle(col)
        const width = parseFloat(styles.width)
        saveFn(index, width)
        return width
      }
      return settings[index]
    }

    const applyWidthToColumn = (col, width) => {
      col.style.width = `${width}px`
      col.style.minWidth = `${width}px`
      col.style.maxWidth = `${width}px`
    }

    const applyWidthToColumnCells = (table, index, width) => {
      const rows = table.querySelectorAll(':scope > tbody > tr')
      rows.forEach((row) => {
        const cells = row.querySelectorAll(':scope > td')
        if (cells.length > 1) {
          const cell = cells[index]
          if (cell) {
            cell.style.width = `${width}px`
            cell.style.minWidth = `${width}px`
            cell.style.maxWidth = `${width}px`
          }
        }
      })
    }

    const setupColumnResizer = (col, table, index, saveFn) => {
      col.querySelector('.resizer')?.remove()
      const resizer = document.createElement('div')
      resizer.classList.add('resizer')
      col.appendChild(resizer)
      createResizableColumn(col, resizer, table, index, saveFn)
    }

    setTimeout(applyColumnResizing, 0)
  }, [data, displayColumns, loading])
}
